import { render, staticRenderFns } from "./CampanhasAgendadas.vue?vue&type=template&id=10985f1e"
import script from "./CampanhasAgendadas.vue?vue&type=script&lang=js"
export * from "./CampanhasAgendadas.vue?vue&type=script&lang=js"
import style0 from "./CampanhasAgendadas.vue?vue&type=style&index=0&id=10985f1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports